var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "opdracht-volumes" }, [
    _vm.opdrachtVolumes.opdPerc > 0
      ? _c("div", [
          _c("span", [
            _vm._v(
              "Opdracht: " +
                _vm._s(_vm.opdrachtVolumes.tewPerc) +
                "% tewerkstelling"
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.opdrachtVolumes.opdUren > 0
      ? _c("div", [
          _c("span", [
            _vm._v(
              "Opdracht: " +
                _vm._s(_vm.opdrachtVolumes.tewUren) +
                "/" +
                _vm._s(_vm.opdrachtVolumes.urenNoemer) +
                " tewerkstelling"
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.opdrachtVolumes.periodeUren > 0
      ? _c("div", [
          _c("span", [
            _vm._v(
              "Opdracht: " +
                _vm._s(_vm.opdrachtVolumes.periodeUren) +
                " uren per periode"
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }